import React, { useState, useEffect } from "react";
import './DiscountCodes.css'

const DiscountCodes= () =>{
  const [codes, setCodes] = useState([]);
  const [newCode, setNewCode] = useState("");
  const [discountType, setDiscountType] = useState("fixed");
  const [value, setValue] = useState("");
  const [expiresAt, setExpiresAt] = useState("");
  const [usageLimit, setUsageLimit] = useState(1);

  // Fetch discount codes from backend
  useEffect(() => {
    fetch(`${process.env.REACT_APP_API_URL}/api/admin/discount-codes`)
      .then((res) => res.json())
      .then((data) => {
        if (data && data.success && Array.isArray(data.codes)) {
          setCodes(data.codes);
        } else {
          setCodes([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching codes:", err);
        setCodes([]);
      });
  }, []);
  
  

  // Generate random code
  const handleGenerateCode = () => {
    const randomCode = Math.random().toString(36).substring(2, 10).toUpperCase();
    setNewCode(randomCode);
  };

  // Save discount code to backend
  const handleSaveCode = async () => {
    if (!newCode || !value || !expiresAt) {
      alert("Please fill all fields before saving.");
      return;
    }

    const payload = {
      code: newCode,
      discountType,
      value: Number(value),
      expiresAt,
      usageLimit: Number(usageLimit),
    };

    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/discount-codes`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });
      const data = await res.json();
      if (data.success) {
        alert("Discount code saved!");
        setCodes([...codes, data.code]);
        setNewCode("");
        setValue("");
        setExpiresAt("");
        setUsageLimit(1);
      } else {
        alert("Error: " + data.message);
      }
    } catch (err) {
      console.error("Error saving code:", err);
      alert("Error saving discount code.");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <h2>Discount Codes</h2>

      {/* Generate + Form */}
      <div style={{ marginBottom: "20px" }}>
        <button onClick={handleGenerateCode}>Generate Code</button>
        <input
          type="text"
          placeholder="Code"
          value={newCode}
          readOnly
          style={{ marginLeft: "10px" }}
        />
        <select
          value={discountType}
          onChange={(e) => setDiscountType(e.target.value)}
          style={{ marginLeft: "10px" }}
        >
          <option value="fixed">Fixed ($)</option>
          <option value="percent">Percent (%)</option>
        </select>
        <input
          type="number"
          placeholder="Value"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          style={{ marginLeft: "10px" }}
        />
        <input
          type="date"
          value={expiresAt}
          onChange={(e) => setExpiresAt(e.target.value)}
          style={{ marginLeft: "10px" }}
        />
        <input
          type="number"
          placeholder="Usage Limit"
          value={usageLimit}
          onChange={(e) => setUsageLimit(e.target.value)}
          style={{ marginLeft: "10px" }}
        />
        <button onClick={handleSaveCode} style={{ marginLeft: "10px" }}>
          Save
        </button>
      </div>

      {/* Table */}
      <table border="1" cellPadding="8" style={{ width: "100%" }}>
        <thead>
          <tr>
            <th>Code</th>
            <th>Type</th>
            <th>Value</th>
            <th>Expiry</th>
            <th>Usage Limit</th>
            <th>Used</th>
          </tr>
        </thead>
        <tbody>
          {codes.length > 0 ? (
            codes.map((c) => (
              <tr key={c._id}>
                <td>{c.code}</td>
                <td>{c.discountType}</td>
                <td>{c.value}</td>
                <td>{new Date(c.expiresAt).toLocaleDateString()}</td>
                <td>{c.usageLimit}</td>
                <td>{c.usedCount}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="6" style={{ textAlign: "center" }}>
                No discount codes yet.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
export default DiscountCodes;
